import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class FrontDeskNotificationAbility extends Ability {
  @service declare authz: AuthzService;

  get canEnable(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_LOCATION_CONFIG_UPDATE_INVITES);
  }
}
